import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "modalTitle"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

import { ref, onMounted } from 'vue';

interface PromptOptions {
  title: string;
  message: string;
  yesAction: () => any;
  noAction?: () => any;
  yesButtonText?: string;
  noButtonText?: string;
  iconClass?: string;
}

interface AlertOptions {
  title: string;
  message: string;
  iconClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackModal',
  setup(__props, { expose: __expose }) {

const modalElement = ref<HTMLElement | null>(null);
let modalInstance: any = null;

const currentTitle = ref<string>('');
const currentMessage = ref<string>('');
const currentYesAction = ref<(() => any) | null>(null);
const currentNoAction = ref<(() => any) | null>(null);
const currentYesButtonText = ref<string>('Yes');
const currentNoButtonText = ref<string>('No');
const currentIconClass = ref<string>('bi-info-circle');

onMounted(() => {
  if (modalElement.value) {
    const bootstrap = (window as any).bootstrap;
    if (bootstrap && bootstrap.Modal) {
      modalInstance = new bootstrap.Modal(modalElement.value);
    }
  }
});

function prompt(options: PromptOptions): void {
  currentTitle.value = options.title;
  currentMessage.value = options.message;
  currentYesAction.value = options.yesAction;
  currentNoAction.value = options.noAction || null;
  currentYesButtonText.value = options.yesButtonText || 'Yes';
  currentNoButtonText.value = options.noButtonText || 'No';
  currentIconClass.value = options.iconClass ? `bi-${options.iconClass}` : 'bi-info-circle';
  
  if (modalInstance) {
    modalInstance.show();
  }
}

function alert(options: AlertOptions): void {
  currentTitle.value = options.title;
  currentMessage.value = options.message;
  currentYesAction.value = () => {
    if (modalInstance) {
      modalInstance.hide();
    }
  };
  currentNoAction.value = null;
  currentYesButtonText.value = 'OK';
  currentIconClass.value = options.iconClass ? `bi-${options.iconClass}` : 'bi-info-circle';
  
  if (modalInstance) {
    modalInstance.show();
  }
}

function handleYes(): void {
  if (currentYesAction.value) {
    currentYesAction.value();
  }
  if (modalInstance) {
    modalInstance.hide();
  }
}

function handleNo(): void {
  if (currentNoAction.value) {
    currentNoAction.value();
  }
  if (modalInstance) {
    modalInstance.hide();
  }
}

__expose({
  prompt,
  alert
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    ref_key: "modalElement",
    ref: modalElement,
    tabindex: "-1",
    "aria-labelledby": "modalTitle",
    "aria-hidden": "true",
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, [
            _createElementVNode("i", {
              class: _normalizeClass(["bi", currentIconClass.value])
            }, null, 2 /* CLASS */),
            _createTextVNode(" " + _toDisplayString(currentTitle.value), 1 /* TEXT */)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(currentMessage.value), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_6, [
          (currentNoAction.value !== null)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
                onClick: handleNo
              }, _toDisplayString(currentNoButtonText.value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: handleYes
          }, _toDisplayString(currentYesButtonText.value), 1 /* TEXT */)
        ])
      ])
    ])
  ], 512 /* NEED_PATCH */))
}
}

})